import { ChangeDetectionStrategy, Component, ElementRef, inject, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppAutofocusDirective } from '../../../../shared/directives/appAutofocus.directive';
import { ChatService } from '../../services/chat.service';
import { firstValueFrom } from 'rxjs';
import { MarkdownPipe } from '../../../../shared/pipes/markdown-pipe';

@Component({
    selector: 'app-chat-agent',
    standalone: true,
    imports: [FormsModule, AppAutofocusDirective, MarkdownPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chat-agent.html',
    styleUrl: './chat-agent.scss',
})
export class ChatAgent {
    readonly isOpen = signal(false);
    readonly chatInput = signal('');
    readonly chatMessages = signal<Array<{ role: 'user' | 'assistant'; text: string }>>([
        { role: 'assistant', text: '¡Hola! ¿En qué puedo ayudarte hoy?' },
    ]);

    readonly chatService = inject(ChatService);

    @ViewChild('chatBody') chatBody?: ElementRef<HTMLDivElement>;

    toggleChat(): void {
        this.isOpen.update((value) => !value);
    }

    closeChat(): void {
        this.isOpen.set(false);
    }

    async sendMessage() {
        const message = this.chatInput().trim();
        if (!message) {
            return;
        }


        let sessionId = localStorage.getItem('sessionId')!;
  
        const response = await firstValueFrom(this.chatService.chat({ prompt: message, sessionId: sessionId }));


        const userMessage = { role: 'user' as const, text: message };
        const responseText = response.response;

        this.chatMessages.update((messages) => [...messages, userMessage, { role: 'assistant', text: responseText }]);
        this.chatInput.set('');
        setTimeout(() => this.scrollToBottom(), 0);
    }

    private scrollToBottom(): void {
        const chatBody = this.chatBody?.nativeElement;
        if (!chatBody) {
            return;
        }

        chatBody.scrollTop = chatBody.scrollHeight;
    }
}
